"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _UploadStatus = require("@studio/constants/UploadStatus");
var _setSourceUploadStatus = _interopRequireDefault(require("./setSourceUploadStatus"));
var _showNotification = _interopRequireDefault(require("../notification/showNotification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function onFailedUpload(dispatch, filename) {
  return function () {
    dispatch((0, _setSourceUploadStatus["default"])(filename, _UploadStatus.UPLOAD_FAILED));
    return dispatch((0, _showNotification["default"])('Upload Failed', {
      type: 'warning'
    }));
  };
}
var _default = exports["default"] = onFailedUpload;